export class ReceiptNotificationDto {
  public pid: string;
  public lp: number; //lastpaid
  public d: number; //recpt date
  public du: number; //due
  public o: boolean; //isdone
  public p: boolean; //ispurch
}
